import React from 'react';
import PropTypes from 'prop-types';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import AndroidIcon from 'housecall-ui/dist/IconsAndImages/Icons/Android';
import WwwIcon from 'housecall-ui/dist/IconsAndImages/Icons/Www';
import AppleIcon from 'housecall-ui/dist/IconsAndImages/Icons/Apple';

const ANDROID = 'Android';
const IPHONE = 'iPhone';
const WEB = 'Web';
const WEB_PORTAL = 'Web portal';

function ActivityFeedEntryPoint({ classes, entryPoint, forToolbar }) {
  let icon = null;
  let text = null;
  if (entryPoint === ANDROID) {
    icon = <AndroidIcon className={classes.icon} />;
    text = ANDROID;
  } else if (entryPoint === IPHONE) {
    icon = <AppleIcon className={classes.icon} />;
    text = IPHONE;
  } else if (entryPoint === WEB_PORTAL) {
    text = WEB;
  } else if (entryPoint != null) {
    text = entryPoint;
  }
  return (
    <Grid container>
      <Grid item xs={2} md={1} className={forToolbar ? classes.forToolbarMargin : null}>
        {icon}
      </Grid>
      <Grid item xs={10} md>
        <Typography variant="body2">{text}</Typography>
      </Grid>
    </Grid>
  );
}

ActivityFeedEntryPoint.propTypes = {
  classes: PropTypes.object,
  entryPoint: PropTypes.string,
  forToolbar: PropTypes.bool,
};

ActivityFeedEntryPoint.defaultProps = {
  classes: {},
  entryPoint: WEB_PORTAL,
  forToolbar: false,
};

export default ActivityFeedEntryPoint;
